import axios, {AxiosResponse} from "axios";
import {APIS} from "../../../../static/apis";

export function checkCompanyVendorId (item: string): Promise<AxiosResponse<{ data: string }>> {
  return axios.get(
    APIS.BASE_AUTH_MS_URL + APIS.CHECK_COMPANY_VENDOR_ID +"/" + item
  );
}
